import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
  width: auto;
  height: 42px;

  gap: 2px;
  padding: 3px;
  display: flex;
  align-items: center;

  border-radius: 999px;
  background-color: ${theme.colors.gray.Cinza_12};

  opacity: ${props => props.disabled ? 0.6 : 1};
`;

export const Option = styled.button`
  all: unset;
  box-sizing: border-box;

  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  cursor: ${props => props.disabled ? "not-allowed" : "pointer"};

  background-color: ${props => props.active ? theme.colors.white.Branco : "transparent"};
  box-shadow: ${props => props.active ? "0 1px 2px rgba(16, 24, 40, 0.06)" : "none"};

  transition: background-color .15s ease, border-color .15s ease;

  >img{
    width: 16px;
    height: 16px;
    opacity: ${props => props.active ? 1 : 0.55};
  }
`;
